export const CATEGORY_RECOMMENDATION_TYPES = {
  INTEREST_BASED: 'interestBased',
  TRENDING_TERTIARY: 'trendingTertiary',
};

// product list slugs
export const AND_DONT_FORGET_THESE_SLUG = 'and-don-t-forget-these';
export const BUDGET_FRIENDLY_PICKS_SLUG = 'budget-friendly-picks';
export const KEEP_IT_CLEAN_SLUG = 'keep-it-clean';
export const KITCHEN_MUST_HAVES_SLUG = 'kitchen-must-haves';
export const REGISTRY_AWARDS_SLUG = 'registry-awards';

export const GET_CUSTOMER_ADDRESS = `
  query getCustomerAddress {
    customer {
      firstname
      lastname
      suffix
      email
      id
      addresses {
        id
        firstname
        lastname
        street
        city
        region {
          region_code
          region
          region_id
        }
        postcode
        country_id
        telephone
        default_shipping
      }
    }
  }
`;
